module.exports = __webpack_public_path__ + "img/logo.fdd0b201.svg";